import { Textarea as DigdirTextarea, } from "@digdir/designsystemet-react";
const Textarea = DigdirTextarea;
Textarea.displayName = "Textarea";
export { Textarea };
//# sourceMappingURL=textarea.js.map